import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import SBProTopNav from '@structural/top-nav.vue';
import SBProPageHeader from '@structural/page-header.vue';
import SBProLayoutDefault from '@structural/layout-default.vue';
import SBProPageSection from '@structural/page-section.vue';
let LeadCapture = class LeadCapture extends Vue {
    constructor() {
        super(...arguments);
        this.errors = {
            firstName: [],
            lastName: [],
            email: [],
            company: [],
        };
        this.firstName = null;
        this.lastName = null;
        this.email = null;
        this.company = null;
    }
    sendEmail() {
        window.Email.send({
            SecureToken: '932997b5-a1d1-4792-a079-f29c6ffdaef9',
            To: 'support@megatechai.com',
            From: "huoshuai303@gmail.com",
            Subject: "官网客户-" + this.firstName + '-' + this.lastName + '-' + this.email + '-' + this.company,
            Body: this.firstName + "<br/>" + this.lastName + "<br/>" + this.email + "<br/>" + this.company
        }).then(
        // message => alert(message)
        this.$bvModal.show('modal-1'));
    }
    onSubmit(event) {
        if (!this.firstName) {
            this.firstName = '';
            this.errors.firstName.push('required');
        }
        if (!this.lastName) {
            this.lastName = '';
            this.errors.lastName.push('required');
        }
        if (!this.email) {
            this.email = '';
            this.errors.email.push('required');
        }
        else if (!this._validEmail(this.email)) {
            this.errors.email.push('email');
        }
        if (!this.company) {
            this.company = '';
            this.errors.company.push('required');
        }
        this.emailValid;
        this.emailInvalid;
        if (!this.hasErrors()) {
            // Do something here, or add action and method to form
            this.sendEmail();
            event.preventDefault();
            // this.$bvModal.show('modal-1');
            return true;
        }
        return event.preventDefault();
    }
    onFirstNameChange() {
        this.errors.firstName = [];
        if (!this.firstName) {
            this.errors.firstName.push('required');
        }
    }
    onLastNameChange() {
        this.errors.lastName = [];
        if (!this.lastName) {
            this.errors.lastName.push('required');
        }
    }
    onEmailChange() {
        this.errors.email = [];
        if (!this.email) {
            this.errors.email.push('required');
        }
        else if (!this._validEmail(this.email)) {
            this.errors.email.push('email');
        }
    }
    onCompanyChange() {
        this.errors.company = [];
        if (!this.company) {
            this.errors.company.push('required');
        }
    }
    hasError(key, error) {
        return !!this.errors[key].find(e => e === error);
    }
    _validEmail(email) {
        const re = RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        return re.test(email);
    }
    hasErrors() {
        for (const key in this.errors) {
            if (this.errors[key].length > 0) {
                return true;
            }
        }
        return false;
    }
    get emailValid() {
        return this.email !== null && !this.emailInvalid;
    }
    get emailInvalid() {
        return (this.email !== null &&
            (this.hasError('email', 'required') ||
                this.hasError('email', 'email')));
    }
    get firstNameValid() {
        return this.firstName !== null && !this.firstNameInvalid;
    }
    get firstNameInvalid() {
        return (this.firstName !== null && this.hasError('firstName', 'required'));
    }
    get lastNameValid() {
        return this.lastName !== null && !this.lastNameInvalid;
    }
    get lastNameInvalid() {
        return this.lastName !== null && this.hasError('lastName', 'required');
    }
    get companyValid() {
        return this.company !== null && !this.companyInvalid;
    }
    get companyInvalid() {
        return this.company !== null && this.hasError('company', 'required');
    }
};
__decorate([
    Watch('firstName')
], LeadCapture.prototype, "onFirstNameChange", null);
__decorate([
    Watch('lastName')
], LeadCapture.prototype, "onLastNameChange", null);
__decorate([
    Watch('email')
], LeadCapture.prototype, "onEmailChange", null);
__decorate([
    Watch('company')
], LeadCapture.prototype, "onCompanyChange", null);
LeadCapture = __decorate([
    Component({
        components: {
            'sbpro-top-nav': SBProTopNav,
            'sbpro-page-header': SBProPageHeader,
            'sbpro-layout-default': SBProLayoutDefault,
            'sbpro-page-section': SBProPageSection,
        },
    })
], LeadCapture);
export default LeadCapture;
